var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
        _c("div", { staticClass: "columns is-mobile" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "box level" }, [
              _vm._m(0),
              _c("div", { staticClass: "level-right" }, [
                _c("p", { staticClass: "level-item is-size-2 pr-6" }, [
                  _vm._v(
                    " " + _vm._s(_vm.formattedStock["7EMP"]?.length || 0) + " "
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "box level" }, [
              _vm._m(1),
              _c("div", { staticClass: "level-right" }, [
                _c("p", { staticClass: "level-item is-size-2 pr-6" }, [
                  _vm._v(
                    " " + _vm._s(_vm.formattedStock["8FUL"]?.length || 0) + " "
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "box level" }, [
              _vm._m(2),
              _c("div", { staticClass: "level-right" }, [
                _c("p", { staticClass: "level-item is-size-2 pr-6" }, [
                  _vm._v(
                    " " + _vm._s(_vm.formattedStock["3REP"]?.length || 0) + " "
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          [
            _c("ag-grid-vue", {
              staticClass: "ag-theme-alpine",
              staticStyle: { height: "500px" },
              attrs: {
                modules: _vm.modules,
                pagination: true,
                "pagination-auto-page-size": true,
                "group-display-type": _vm.groupDisplayType,
                "grid-options": _vm.gridOptions,
                "row-data": _vm.stock,
                "column-defs": _vm.columnDefs,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "level-left" }, [
      _c("p", { staticClass: "level-item" }, [_vm._v(" Empty crates ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "level-left" }, [
      _c("p", { staticClass: "level-item" }, [_vm._v(" Full crates ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "level-left" }, [
      _c("p", { staticClass: "level-item" }, [_vm._v(" Damaged crates ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }